import React, { useState, useEffect, useMemo } from 'react'; // Tambahkan useMemo
import api from '../api/axiosConfig';
import { debounce } from 'lodash';

const PenggunaKendaraanForm = ({ existingData, onSave, onCancel }) => {
  const [kendaraanList, setKendaraanList] = useState([]);
  const [kendaraan, setKendaraan] = useState('');
  const [nama, setNama] = useState('');
  const [jabatan, setJabatan] = useState('');
  const [nomerHp, setNomerHp] = useState('');
  const [email, setEmail] = useState('');
  const [file, setFile] = useState(null);

  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  
  const [loadingKendaraan, setLoadingKendaraan] = useState(true);
  
  useEffect(() => {
    const fetchKendaraan = async () => {
      setLoadingKendaraan(true);
      try {
        const response = await api.get('/api/kendaraan?limit=1000');
        setKendaraanList(response.data.data || []);
      } catch (error) {
        console.error("Gagal mengambil daftar kendaraan:", error);
        setKendaraanList([]); // Set ke array kosong jika error
      } finally {
          setLoadingKendaraan(false);
      }
    };
    // ------------------------------------
    fetchKendaraan();

    const data = existingData || {};
    setKendaraan(data.kendaraan?._id || '');
    setNama(data.nama || '');
    setJabatan(data.jabatan || ''); // Perbaikan: Gunakan data.jabatan
    setNomerHp(data.nomerHp || '');
    setEmail(data.email || '');
    setFile(null); // Selalu reset pilihan file
  }, [existingData]);

  const fetchSuggestions = async (query) => {
    if (query.length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    try {
      const { data } = await api.get(`/api/pengguna-kendaraan/jabatan-suggestions?q=${query}`);
      setSuggestions(data);
      setShowSuggestions(true);
    } catch (error) {
      console.error("Gagal mengambil saran jabatan:", error);
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const debouncedFetchSuggestions = useMemo(
    () => debounce((query) => fetchSuggestions(query), 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleJabatanChange = (e) => {
    const value = e.target.value;
    setJabatan(value);
    debouncedFetchSuggestions(value);
  };

  const handleSuggestionClick = (suggestion) => {
    setJabatan(suggestion);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('kendaraan', kendaraan);
    formData.append('nama', nama);
    formData.append('jabatan', jabatan);
    formData.append('nomerHp', nomerHp);
    formData.append('email', email);
    if (file) {
      formData.append('file', file);
    }
    // Panggil fungsi dari parent untuk mengirim data
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="form-card" onClick={() => setShowSuggestions(false)}>
        <div className="form-group">
            <label>Nomor Kendaraan</label>
            <select value={kendaraan} onChange={(e) => setKendaraan(e.target.value)} required disabled={loadingKendaraan}>
                <option value="">{loadingKendaraan ? 'Memuat kendaraan...' : '-- Pilih Kendaraan --'}</option>
                {Array.isArray(kendaraanList) && kendaraanList.map(k => (
                    <option key={k._id} value={k._id}>{k.nomorKendaraan} - {k.jenis}</option>
                ))}
            </select>
        </div>
        <div className="form-group"><label>Nama</label><input type="text" value={nama} onChange={(e) => setNama(e.target.value)} required /></div>
        <div className="form-group autocomplete-container">
          <label>Jabatan</label>
          <input
            type="text"
            value={jabatan}
            onChange={handleJabatanChange}
            onFocus={() => { if(jabatan.length >= 2) setShowSuggestions(true); }}
            onClick={(e) => e.stopPropagation()}
            required
            autoComplete="off"
          />
          {showSuggestions && suggestions.length > 0 && (
            <ul className="suggestions-list">
              {suggestions.map((s, index) => (
                <li 
                  key={index} 
                  className="suggestion-item" 
                  onClick={() => handleSuggestionClick(s)}
                >
                  {s}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="form-group"><label>Nomor HP</label><input type="text" value={nomerHp} onChange={(e) => setNomerHp(e.target.value)} required /></div>
        <div className="form-group"><label>Email</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
        <div className="form-group"><label>File (PDF)</label><input type="file" onChange={(e) => setFile(e.target.files[0])} accept="application/pdf" /></div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #f0f0f0' }}>
            <button type="button" onClick={onCancel} className="btn-secondary">Batal</button>
            <button type="submit" className="btn-primary">Simpan</button>
        </div>
    </form>
  );
};

export default PenggunaKendaraanForm;